import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export function selectedTicketsValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const objects = control.value;

        if (!Array.isArray(objects)) {
            return { notArray: true };
        }

        if (objects.length === 0) {
            return { emptyArray: true };
        }

        const hasInvalidObject = objects.some(obj => 
            typeof obj !== 'object' || 
            !obj.hasOwnProperty('name') || 
            typeof obj.name !== 'string'
        );

        if (hasInvalidObject) {
            return { invalidObject: true };
        }

        return null;
    };
}
